import React from 'react';

import { colors, styled } from 'core/styles';
import { FormattedAmount } from 'components';
import { ratingToLetter } from 'domain/types';

import { TvlTreeNodeContentProps } from './types';

export function TvlTreemapTooltip({
  active,
  payload,
}: {
  active: boolean;
  payload: { payload: TvlTreeNodeContentProps }[];
}) {
  if (!active || !payload.length || payload[0].payload.depth === 0) {
    return null;
  }

  const node = payload[0].payload.depth === 1 ? payload[0].payload : payload[0].payload.root;

  if (!node) {
    return null;
  }

  const { tvl, valueAtRisk, name } = node;
  const rating = 'rating' in node ? node.rating : null;

  return (
    <Root>
      <TooltipLabel>{name}</TooltipLabel>
      <TooltipContent>
        {rating && (
          <span>
            Health:{' '}
            {rating.fold(
              r => ratingToLetter(r),
              () => '-',
            )}
          </span>
        )}

        {tvl && (
          <span>
            <FormattedAmount sum={tvl} precision={2} symbolSize="inherit" withSI /> TVL
          </span>
        )}
        {valueAtRisk && (
          <span>
            Value at risk:{' '}
            <FormattedAmount sum={valueAtRisk} precision={2} symbolSize="inherit" withSI />
          </span>
        )}
      </TooltipContent>
    </Root>
  );
}

const Root = styled('div')(() => ({
  padding: '4px 8px 6px 8px',
  background: colors.blackOpacity[8],
  backdropFilter: 'blur(20px)',
  borderRadius: 4,
  fontSize: 12,
}));

const TooltipLabel = styled('div')({
  width: '100%',
  paddingBottom: 6,
  borderBottom: `solid 1px ${colors.blackOpacity[8]}`,
});

const TooltipContent = styled('div')(() => ({
  marginTop: 7,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
}));
